/** 1ページあたりの表示件数 */
export const PAGE_LIMIT = 30;

/**
 * 現在ページの表示開始番号を返す。
 * 例: pageNo=1, limit=30 → 1, pageNo=2 → 31
 */
export function getPageStartNum(pageNo: number, limit: number): number {
  return pageNo * limit - limit + 1;
}

/**
 * 現在ページの表示終了番号を返す。
 * 次ページが存在する場合は pageNo*limit、そうでなければ totalCount を返す。
 */
export function getPageEndNum(
  pageNo: number,
  limit: number,
  hasNext: boolean,
  totalCount: number
): number {
  return hasNext ? pageNo * limit : totalCount;
}

/**
 * 次ページが存在するかを返す。
 * pageNo*limit < totalCount のとき true。
 */
export function computeHasNext(pageNo: number, limit: number, totalCount: number): boolean {
  return pageNo * limit < totalCount;
}
